import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DeleteMemberContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DeleteMemberProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete("settings/members/delete", {
        data: payload,
      });
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <DeleteMemberContext.Provider value={contextValue}>
      {children}
    </DeleteMemberContext.Provider>
  );
};

export default DeleteMemberProvider;
